module.exports = __webpack_public_path__ + "img/card3@2x.e53324e1.png";